var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgİconLanguagePinkEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.399.794H1.6c-.883,0-1.6.715-1.6,1.6v8.809c0,.885.717,1.6,1.6,1.6h3.982l1.974,2.958c.049.074.116.134.193.176.077.041.163.062.251.062s.174-.022.253-.062c.077-.042.142-.102.191-.176l1.977-2.958h3.98c.885,0,1.6-.715,1.6-1.6V2.394c0-.885-.715-1.6-1.6-1.6h-.002ZM7.186,10.004H2.681V3.425h4.496v1.017h-3.177v1.654h2.725v1.017h-2.725v1.875h3.185v1.017h0ZM13.314,10.004h-1.315l-2.657-4.497-.027.005v4.492h-1.319V3.425h1.319l2.657,4.492.027-.005V3.425h1.315v6.58h0Z",
    fill: "#da45f4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconLanguagePinkEn);
export default __webpack_public_path__ + "static/media/icon_language-pink_en.b603208fb13ae5272b1fa202b37a62f6.svg";
export { ForwardRef as ReactComponent };